var render = function render(){var _vm=this,_c=_vm._self._c;return _c('CSidebar',{attrs:{"fixed":"","minimize":_vm.minimize,"show":_vm.show},on:{"update:show":function($event){_vm.show=$event}}},[_c('CSidebarBrand'),_c('CRenderFunction',{attrs:{"flat":"","content-to-render":_vm.activeNav}}),_c('CSidebarMinimizer',{staticClass:"d-md-down-none",nativeOn:{"click":function($event){_vm.minimize = !_vm.minimize}}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }